import script from "./privacy_summary_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy_summary_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__